// extracted by mini-css-extract-plugin
export default {"saveForLater":"_1y8VW"};